import React from "react";
import { Space, Typography, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useLicensesState } from "src/reducers/subscription";
import { currency } from "./subscriptionDrawerUtil";
import { useLanguage } from "src/providers/LanguageProvider";

const { Text } = Typography;

export default function SubscriptionDrawerFooter() {
  const { t } = useLanguage();
  const { selected } = useLicensesState();

  if (!selected) return null;

  const monthlyTotal = Number(selected.totalAmount ?? 0);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Space>
        <Text type="secondary">{t("MONTHLY_TOTAL")}</Text>
        <Tooltip title={t("MONTHLY_TOTAL_HINT")}>
          <InfoCircleOutlined aria-label={t("MONTHLY_TOTAL_HINT")} />
        </Tooltip>
      </Space>
      <Text strong style={{ fontSize: 16 }}>{currency(monthlyTotal)}</Text>
    </div>
  );
}
